import React from 'react';
import Icon from '../../../components/AppIcon';

const IndustrySelection = ({ selectedIndustry, onIndustrySelect }) => {
  const industries = [
    {
      id: 'tech',
      label: 'Technology',
      description: 'Software, data, product, DevOps',
      icon: 'Code',
      tracks: ['Software Engineering', 'Data & AI', 'Product Management', 'DevOps & Infrastructure']
    },
    {
      id: 'construction',
      label: 'Construction',
      description: 'Building, civil, industrial',
      icon: 'HardHat',
      tracks: ['Building Construction', 'Civil Engineering', 'Industrial Projects']
    },
    {
      id: 'realestate',
      label: 'Real Estate',
      description: 'Development, property management',
      icon: 'Building',
      tracks: ['Real Estate Development', 'Property Management', 'Commercial Real Estate']
    }
  ];

  return (
    <div className="w-full">
      <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground mb-2">
        Select Your Industry
      </h2>
      <p className="text-sm md:text-base lg:text-lg text-muted-foreground mb-6 md:mb-8">
        Choose your primary industry to receive tailored questions
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {industries?.map((industry) => (
          <button
            key={industry?.id}
            onClick={() => onIndustrySelect(industry?.id)}
            className={`w-full min-w-0 p-6 md:p-8 rounded-2xl border-2 transition-all duration-250 text-left ${
              selectedIndustry === industry?.id
                ? 'border-primary bg-primary/5' :'border-border bg-card hover:border-primary/50'
            }`}
          >
            <div className="flex flex-col gap-4">
              <div className="flex items-start justify-between">
                <div
                  className={`w-12 h-12 md:w-14 md:h-14 rounded-xl flex items-center justify-center flex-shrink-0 ${
                    selectedIndustry === industry?.id
                      ? 'bg-primary text-primary-foreground'
                      : 'bg-muted text-muted-foreground'
                  }`}
                >
                  <Icon name={industry?.icon} size={24} />
                </div>
                {selectedIndustry === industry?.id && (
                  <Icon name="Check" size={20} color="var(--color-primary)" />
                )}
              </div>
              
              <div>
                <h3 className="text-lg md:text-xl font-semibold text-foreground mb-1">
                  {industry?.label}
                </h3>
                <p className="text-sm md:text-base text-muted-foreground mb-3">
                  {industry?.description}
                </p>
                
                <div className="flex flex-wrap gap-2">
                  {industry?.tracks?.map((track, index) => (
                    <span
                      key={index}
                      className="px-3 py-1 rounded-full text-xs md:text-sm bg-muted text-muted-foreground"
                    >
                      {track}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default IndustrySelection;